import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';

import { NgSelectModule } from '@ng-select/ng-select';
import { TextMaskModule } from 'angular2-text-mask';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination'; 
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxLoadingModule } from 'ngx-loading';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

 import { ColorsService } from './colors/colors.service';

import { TabDirective } from './directives/tab/tab.directive';
import { TabService } from './directives/tab/tab.service';
import { AutofocusDirective } from './directives/tab/autofocus.directive'
import { NumericDirective } from './directives/tab/number.directive'
import { UploadModule } from '@progress/kendo-angular-upload';

import { LinkViewComponent } from '../shared/components/public/linkview.component';
import { ButtonViewComponent } from '../shared/components/public/buttonview.component';
import { NumberViewComponent } from '../shared/components/public/numberview.component';
import { DateViewComponent } from '../shared/components/public/dateview.component';
import { DateView2Component } from '../shared/components/public/dateview2.component';
import { RowExpandViewComponent } from '../shared/components/public/rowexpandview.component';
import { RowHoaHongViewComponent } from '../shared/components/public/rowhoahongview.component';
import { DynamicHostDirective } from './directives/dynamichost.directive';
import { HideIfUnauthorizedDirective } from './directives/hide-if-unauthorized.directive';
import { DisableIfUnauthorizedDirective } from './directives/disable-if-unauthorized.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { Repository } from '../services/repository'
import { AuthorizationService } from '../services/authorization.service'
import { ToasterService } from 'angular2-toaster/angular2-toaster';


import { danhmucchungeditComponent } from './components/danhmuc/danhmucchungedit.component'
import { doituongchungeditComponent } from './components/danhmuc/doituongchungedit.component'
import { capdonvieditComponent } from './components/danhmuc/capdonviedit.component'
import { thitruongeditComponent } from './components/danhmuc/thitruongedit.component'
import { duaneditComponent } from './components/danhmuc/duanedit.component'
import { kybaocaoeditComponent } from './components/danhmuc/kybaocaoedit.component'
import { cauhinhchitieubaocaoeditComponent } from './components/danhmuc/cauhinhchitieubaocaoedit.component'
import { hanghoaeditComponent } from './components/danhmuc/hanghoaedit.component'
import { nhacungcapeditComponent } from './components/danhmuc/nhacungcapedit.component'
import { khachhangeditComponent } from './components/danhmuc/khachhangedit.component'
import { giayphepeditComponent } from './components/nhaplieu/giayphepedit.component'
import { khoxangdaueditComponent } from './components/danhmuc/khoxangdauedit.component'
import { khoxangdauchitieteditComponent } from './components/danhmuc/khoxangdauchitietedit.component'

import { maubaocaoeditComponent } from './components/tonghop/maubaocaoedit.component'
import { importeditComponent } from './components/tonghop/importedit.component'
import { importqteditComponent } from './components/tonghop/importqtedit.component'
import { tuychinhmaubceditComponent } from './components/tonghop/tuychinhmaubcedit.component'
import { luoichitieteditComponent } from './components/tonghop/luoichitietedit.component'
import { luoitonghopeditComponent } from './components/tonghop/luoitonghopedit.component'
import { chonchitieueditComponent } from './components/tonghop/chonchitieuedit.component'
import { danhsachdonvieditComponent } from './components/tonghop/danhsachdonviedit.component'
import { chondonvieditComponent } from './components/tonghop/chondonviedit.component'
import { chondonvicaptreneditComponent } from './components/tonghop/chondonvicaptrenedit.component'
import { chondonvibanleeditComponent } from './components/tonghop/chondonvibanleedit.component'
import { taikhoannganhangeditComponent } from './components/quantri/taikhoannganhangedit.component'
import { chontaikhoannganhangeditComponent } from './components/tonghop/chontaikhoannganhangedit.component'
import { danhsachcapsogiayphepeditComponent } from './components/tonghop/danhsachcapsogiayphepedit.component'
import { chucvueditComponent } from './components/danhmuc/chucvuedit.component'
import { danhsachnhanvieneditComponent } from './components/hoso/danhsachnhanvienedit.component'
import { nhanvieneditComponent } from './components/hoso/nhanvienedit.component'



import { donvieditComponent } from './components/quantri/donviedit.component'
import { phanheeditComponent } from './components/quantri/phanheedit.component'
import { donvibanleeditComponent } from './components/quantri/donvibanleedit.component'
import { auditlichsuviewComponent } from './components/quantri/auditlichsuview.component'
import { ChuyenTrangThaiActionComponent } from './components/nghiepvu/chuyentrangthai-action.component'



import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { NgxCurrencyModule } from "./directives/currencymask/currency-mask.module";

//import { NgxCurrencyModule } from 'ngx-currency';

import { Ng2SmartTableModule } from 'ng2-smart-table';

import { FlotDirective } from './directives/flot/flot.directive';
//import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';

import { NgxTreeSelectModule, ExpandMode } from 'ngx-tree-select';
import { FileUploadModule } from 'ng2-file-upload';

import { UploaderModule } from '@syncfusion/ej2-angular-inputs';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
       
        CollapseModule.forRoot(),
      Ng2SmartTableModule,
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
      NgxLoadingModule.forRoot({}),
      TabsModule.forRoot(),
      Ng2Bs3ModalModule,
      DateInputsModule,
      NgxCurrencyModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
        NgSelectModule,
        TextMaskModule,
      ToasterModule,
      UploadModule,
      FileUploadModule,
      UploaderModule,
      NgxTreeSelectModule.forRoot({
        idField: 'id',
        textField: 'name',
        expandMode: ExpandMode.Selection
      }) 
    ],
    providers: [
        ColorsService,
        TabService,
        Repository,
        ToasterService,
        AuthorizationService,
    ],
    declarations: [
      FlotDirective,
      EasypiechartDirective,
      AutofocusDirective,
      NumericDirective,
        TabDirective,
        NumberViewComponent,
      ButtonViewComponent,
      LinkViewComponent,
      DateViewComponent,
      DateView2Component,
        RowExpandViewComponent,
        RowHoaHongViewComponent,
      HideIfUnauthorizedDirective,
      DynamicHostDirective,
      DisableIfUnauthorizedDirective,
      SafeHtmlPipe,

      danhmucchungeditComponent,
      doituongchungeditComponent,
      capdonvieditComponent,
      thitruongeditComponent,
      duaneditComponent,
      hanghoaeditComponent,
      nhacungcapeditComponent,
      khachhangeditComponent,
      khoxangdaueditComponent,
      khoxangdauchitieteditComponent,
      giayphepeditComponent,
      kybaocaoeditComponent,
      cauhinhchitieubaocaoeditComponent,
      maubaocaoeditComponent,
      importeditComponent,
      importqteditComponent,
      tuychinhmaubceditComponent,
      luoichitieteditComponent,
      luoitonghopeditComponent,
      chonchitieueditComponent,
      danhsachdonvieditComponent,
      chondonvieditComponent,
      chondonvicaptreneditComponent,
      chondonvibanleeditComponent,
      taikhoannganhangeditComponent,
      chontaikhoannganhangeditComponent,
      danhsachcapsogiayphepeditComponent,
      chucvueditComponent,
      danhsachnhanvieneditComponent,
      nhanvieneditComponent,
      donvieditComponent,
      donvibanleeditComponent,
      phanheeditComponent,
      auditlichsuviewComponent,
      ChuyenTrangThaiActionComponent,

      ],
    entryComponents: [        
        NumberViewComponent,
      ButtonViewComponent,
      LinkViewComponent,
      DateViewComponent,
      DateView2Component,
        RowExpandViewComponent,
      RowHoaHongViewComponent,
      danhmucchungeditComponent,
        doituongchungeditComponent,
      capdonvieditComponent,
      thitruongeditComponent,
      duaneditComponent,
      hanghoaeditComponent,
      nhacungcapeditComponent,
      khachhangeditComponent,
      khoxangdaueditComponent,
      khoxangdauchitieteditComponent,
      giayphepeditComponent,
      kybaocaoeditComponent,
      cauhinhchitieubaocaoeditComponent,
       maubaocaoeditComponent,
      importeditComponent,
      importqteditComponent,
      tuychinhmaubceditComponent,
      luoichitieteditComponent,
      luoitonghopeditComponent,
      chonchitieueditComponent,
      danhsachdonvieditComponent,
      chondonvieditComponent,
      chondonvicaptreneditComponent,
      chondonvibanleeditComponent,
      taikhoannganhangeditComponent,
      chontaikhoannganhangeditComponent,
      danhsachcapsogiayphepeditComponent,
      chucvueditComponent,
      danhsachnhanvieneditComponent,
      nhanvieneditComponent,
      donvieditComponent,
      donvibanleeditComponent,
      phanheeditComponent,
      auditlichsuviewComponent,
      ChuyenTrangThaiActionComponent,

      ],
  exports: [
    FlotDirective,
    EasypiechartDirective,
    NgxCurrencyModule,
        CommonModule,
        FormsModule,
        NgSelectModule,
        TextMaskModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,       
        CollapseModule,      
        BsDropdownModule,
    ModalModule,
    FileUploadModule,
    UploaderModule,
        PaginationModule,
        ProgressbarModule,
      NgxLoadingModule,
        TabsModule,       
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
    ToasterModule,
    NgxTreeSelectModule,
        TabDirective,
    AutofocusDirective,
    NumericDirective,
    HideIfUnauthorizedDirective,
    DynamicHostDirective,
    DisableIfUnauthorizedDirective,
    SafeHtmlPipe,

    danhmucchungeditComponent,
    doituongchungeditComponent,
    capdonvieditComponent,
    thitruongeditComponent,
    duaneditComponent,
    hanghoaeditComponent,
    nhacungcapeditComponent,
    khachhangeditComponent,
    khoxangdaueditComponent,
    khoxangdauchitieteditComponent,
    giayphepeditComponent,
    kybaocaoeditComponent,
    cauhinhchitieubaocaoeditComponent,
    maubaocaoeditComponent,
    importeditComponent,
    importqteditComponent,
      tuychinhmaubceditComponent,
    luoichitieteditComponent,
    luoitonghopeditComponent,
    chonchitieueditComponent,
    danhsachdonvieditComponent,
    chondonvieditComponent,
    chondonvicaptreneditComponent,
    chondonvibanleeditComponent,
    taikhoannganhangeditComponent,
    chontaikhoannganhangeditComponent,
    danhsachcapsogiayphepeditComponent,
    chucvueditComponent,
    danhsachnhanvieneditComponent,
    nhanvieneditComponent,
    donvieditComponent,
    donvibanleeditComponent, 
    phanheeditComponent,
    auditlichsuviewComponent,
    ChuyenTrangThaiActionComponent,
  ]
})


export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}
 
